import Vue from 'vue'

const arabic = {
    install(Vue) {
        Vue.filter('arabic', function (input) {
            if (!input) { return "0"; }
            if (isNaN(input)) { return "0"; }
            input = parseFloat(input);
            return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
    }
}

Vue.use(arabic)